<template>
  <div>
    <Row>
      <Col span="6">
        <div class="search-con">
          <!-- <Button @click="showGroupModal()" v-if="this.$getMenuAuthority('sys:group:save')" class="search-btn" type="success"><Icon type="search"/>添加</Button>
          <Button @click="showUpdateGroupModal()" v-if="this.$getMenuAuthority('sys:group:update')" class="search-btn" type="success"><Icon type="search"/>修改</Button>
          <Button @click="deleteGroup(false)" v-if="this.$getMenuAuthority('sys:group:delete')" class="search-btn" type="error"><Icon type="search"/>删除</Button> -->
        </div>
        <Tree ref="roletree" @on-select-change="selectChange()" :data="roleList"></Tree>
        <Modal v-model="editGroupShow" @on-ok="saveGroupInfo()" scrollable title="编辑">
          <Form ref="groupParam" :model="groupParam" :rules="groupRuleValidate" :label-width="80" class="edit-win">
          <FormItem label="父级分组" prop="type" v-if="groupParam.id != ''">
            <Select v-model="groupParam.pid" style="width:380px;">
                <Option v-for="item in parentGroupList" :key="item.id" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
            <FormItem label="分组名称" prop="name">
              <Input v-model="groupParam.name" placeholder="请输入分组名称" style="width: 380px"></Input>
            </FormItem>
            <FormItem label="保单前缀" prop="prefix">
              <Input v-model="groupParam.prefix" placeholder="请输入保单前缀不要带日期" style="width: 380px"></Input>
            </FormItem>
            <FormItem label="分组类型" prop="type">
              <Select v-model="groupParam.type" :disabled="groupParam.id != ''" style="width:380px;" >
                  <Option v-for="item in groupType" :key="item.id" :value="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
            <FormItem label="选取模板" prop="type">
              <Select v-model="groupParam.mid" multiple style="width:380px;">
                  <Option v-for="item in modelList" :key="item.id" :value="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Form>
        </Modal>
      </Col>
      <Col span="18">
        <div class="search-con">
          <Button @click="editInfo(false)" class="search-btn"  v-if="this.$getMenuAuthority('sys:template:save')" type="primary"><Icon type="search"/>新增</Button>
        </div>
        <Table border :columns="columns1" :data="showData.list"></Table> 
        <div class="page-con">
          <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editGroupShow: false,  //编辑分组
      checkGroupType: '',
      roleList: [], //格式化成树状图
      roleOriginalList: [], //原始分组列表
      modelList:[],  //模板列表
      param: {              //查询条件
        username: '',
      },
      parentGroupList: [],
      groupParam: {
        name: '',
        type: '',
        pid: '',
        groupModelList: [],
        mid: '',
        id:'',
      },
      tempCheckNode: { //选中节点
        id:'',
        name: '',
        type: '',
        pid: '',
        groupModelList: [],
        mid: '',
      },
      groupRuleValidate: {
        name: [
          { required: true, message: '模板名不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '模板地址不能为空', trigger: 'blur' }
        ],
        mid: [
          { required: true, message: '模板打印时长不能为空', trigger: 'blur' }
        ],
      },
      showData: {           //列表容器
        pageNum: 1
      },
      columns1: [           //表头
       {title: '车行名',key: 'groupname'},
       {title: '服务产品',key: 'bdservice'},
        {title: '模板名',key: 'templatename'},        
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'primary',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:template:update') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.editInfo(true,params.row.id,params.row.chid,params.row.bdserviceid,params.row.template)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:template:delete') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      groupType: []
    }
  },
  activated() {
    this.getAllGroup()
    this.getList ()
    this.getModel()
    this.getGroupList()
  },
  mounted () {
    this.getAllGroup()
    this.getList ()
    this.getModel()
    this.getGroupList()
  },
  methods: {
    searchInfo() {
      this.showData.pageNum = 1
      this.getList()
    },
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    isCheckGroup() {
      let tempdate = this.$refs.roletree.getSelectedNodes()
      if(tempdate.length>0) {
        this.groupParam.pid = tempdate[0].id
        return true
      } else {
        this.$Message.warning('请选中一个分组')
        return false
      }
    },
    getAllGroup() {
      this.$axios.get('/group/selectAllMob')
        .then(function (response) {
          if (response.data.success) {
            this.parentGroupList = response.data.data
          } else {
            this.$Message.error(response.data.errMsg)
          }
        }.bind(this))

    },
    selectChange() {
      this.tempCheckNode = this.$refs.roletree.getSelectedNodes()[0]
      this.getList()
    },
    showGroupModal() {
      this.groupParam = {
        name: '',
        type: '',
        pid: '',
        groupModelList: [],
        mid: '',
        id:'',
      }
      this.groupParam.id = ''
      this.groupParam.pid = this.tempCheckNode
      this.checkGroupType = this.$refs.roletree.getSelectedNodes()[0].type
      this.groupType = []
      if(this.checkGroupType == 0) {
        this.groupType.push({id:0,name:'管理员'})
        this.groupType.push({id:1,name:'总账号'})
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'门店'})        
        this.groupType.push({id:4,name:'大区'})
        this.groupType.push({id:5,name:'小区'})
        this.groupType.push({id:6,name:'战区'})
      }
      if(this.checkGroupType == 1) {
        this.groupType.push({id:1,name:'总账号'})
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'门店'})        
        this.groupType.push({id:4,name:'大区'})
        this.groupType.push({id:5,name:'小区'})
        this.groupType.push({id:6,name:'战区'})
      }
      if(this.checkGroupType == 2) {
        this.groupType.push({id:3,name:'门店'})
      }
      if(this.checkGroupType == 6) {
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'车行'})
        this.groupType.push({id:5,name:'大区'})
        this.groupType.push({id:6,name:'小区'})
      }
      if(this.checkGroupType == 5) {
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'车行'})
      }
      if(this.checkGroupType == 4) {
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'车行'})
        this.groupType.push({id:6,name:'小区'})
      }
      if(this.isCheckGroup()) {
        if(this.checkGroupType == 3) {
          this.$Message.warning('车行已经是最低添加等级')
          return
        }
        this.editGroupShow = true
      }
    },
    showUpdateGroupModal() {
      if(this.isCheckGroup()) {
        this.groupType.push({id:0,name:'管理员'})
        this.groupType.push({id:1,name:'总账号'})
        this.groupType.push({id:2,name:'集团'})
        this.groupType.push({id:3,name:'门店'})        
        this.groupType.push({id:4,name:'大区'})
        this.groupType.push({id:5,name:'小区'})
        this.groupType.push({id:6,name:'战区'})
        this.$axios.get('/group/info/'+this.tempCheckNode.id)
          .then(function (response) {
            if (response.data.success) {
              response.data.data.mid = []
              response.data.data.groupModelList.forEach(element => {
                response.data.data.mid.push(element.mid)
              });
              this.groupParam = response.data.data
            } else {
              this.$Message.error(response.data.errMsg)
            }
          }.bind(this))
        this.editGroupShow = true
      }
    },
    deleteGroup() {
      if(this.isCheckGroup()) {
        this.$Modal.confirm({
          title: '删除',
          content: '<p>您确定要删除吗</p>',
          onOk: () => {
            this.$Loading.start()
            this.$axios.get('/group/delete/'+this.groupParam.pid) //     /gets/group/2
            .then(function (response) {
              if (response.data.success) {
                this.getGroupList()
                this.$Loading.finish()
              } else {
                this.$Message.error(response.data.errMsg)
                this.$Loading.error()
              }
            }.bind(this))
          },
          onCancel: () => {
            this.$Message.warning('已取消删除')
          }
        })
      }
    },
    saveGroupInfo() {
      this.$Loading.start()
      let url
      if(this.groupParam.id == '') {
        url = '/group/save'
      } else {
        url = '/group/update'
        this.groupParam.mid.forEach(element => {
        this.groupParam.groupModelList.push({mid:element})
      });
      }
      this.groupParam.groupModelList = []

      this.$axios.post(url,this.groupParam)
      .then(function (response) {
        if (response.data.success) {
          this.getGroupList()
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getModel() {
      this.$Loading.start()
      this.$axios.get('/model/select')
      .then(function (response) {
        if (response.data.success) {
          if(response.data.data.length>0) {
            this.modelList = response.data.data
            this.$Loading.finish()
          }
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getGroupList() {
      this.$Loading.start()
      this.$axios.get('/group/moblist')
      .then(function (response) {
        if (response.data.success) {
          if(response.data.data.length>0) {
            this.roleOriginalList = response.data.data
            this.roleList = this.getChild(0,response.data.data[0].pid, response.data.data)
            this.$Loading.finish()
          }
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getChild (count,id, data, selected) {
      count++
      let tempList = []
      let tempNode
      //循环格式化tree所需数据
      for(let i = 0; i<data.length; i++) {
        let element = data[i]
        if(element.pid == id) {
          tempNode = {
            id: element.id,
            title: element.name+'('+this.getTypeById(element.type)+')',
            type: element.mobtype,
            expand: true,
            checked: false,
            children: this.getChild(count,element.id,data)
          }
          tempList.push(tempNode)
        }
      }
      return tempList
    },
    getTypeById(id) {
       if (id == 0) {
        return '管理员'
      } else if (id == 1) {
        return '总账号'
      } else if (id == 2) {
        return '集团'
      } else if (id == 3) {
        return '门店'
      } else if (id == 4) {
        return '大区'
      } else if (id == 5) {
        return '小区'
      } else if (id == 6) {
        return '战区'
      }
    },
    getList () {
      this.$Loading.start()
      this.$axios.get('/template/list/' + this.showData.pageNum + '/' +this.tempCheckNode.id)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    editInfo (isbool,id,chid,bdserviceid,template) {
      //如果id存在直接跳转编辑 id不存在则判断是否有选中分组
      if(isbool) {
        this.$router.push({path:'/templatepdf/edit',query:{chid:chid,bdserviceid:bdserviceid,template:template,id:id}})
      } else {
        if(this.isCheckGroup()) {
        this.$router.push({path:'/templatepdf/edit',query:{groupid:this.groupParam.pid}})
        }
      }
    },
    deleteInfo (id) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
            //let tempfrom = [id]
            console.log('id:'+id)
            this.$axios.get('/template/del/' +id)
            .then(function (response) {
                if (response.data.success) {
                  this.getList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/templatepdf/list.vue